import infrastructuurApi from "../../../api/infrastructuurApi";
import mergeDeep from "../../../util/mergeDeep";
import { orderByPropertyName } from "../../../util/orderBy";

import * as messages from "../../../constants/ToastrConstants";
import { showToastrError, showToastrInfo, showToastrSuccess } from "../../../util/toastr";

export default class InfrastructuurOverzichtPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const isNew = context.props.isNew;
        const disabled = context.props.disabled;
        const params = context.props.match.params;
        const transactieId = params.transactieId;

        ajaxActions.started();

        if (!context.state.showAddInfrastructurenForm) {
            infrastructuurApi.getInfrastructurenBySportclub(transactieId, isNew)
                .then((response) => {
                    ajaxActions.ended();
                    this.processModel(response.data.model.infrastructuren, response.data.model.nieuweInfrastructuren, response.data.model.id, response.data.model.sportclubNaam || "Nieuwe sportclub", response.data.tabSettings, true, false, transactieId);
                })
                .catch((ex) => {
                    ajaxActions.failed();
                    if (ex.response.status === 404) {
                        showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
                        context.setState({ hasUnsavedChanges: false });
                        context.props.setHasUnsavedChanges(false);
                        this.redirector.goTo("/federatie/overzicht");
                    }
                    else {
                        context.props.throwException(ex, true);
                    }
                });
        }
    }

    processModel(infrastructuren, nieuweInfrastructuren, sportclubId, sportclubNaam, tabSettings, setOriginal, hasUnsavedChanges, transactionId) {
        const context = this.context;
        let models = [...infrastructuren.map(x => mergeDeep({}, x))];

        if (tabSettings)
            context.props.setTabSettings(tabSettings);

        if (transactionId)
            context.props.setActiveTransaction(transactionId);

        models = this.sortInfrastructuren([...infrastructuren.map(x => mergeDeep({}, x))]);

        if (setOriginal) {
            const origineleInfrastructuren = models.map(x => mergeDeep({}, x));

            context.setState({
                sportclubId,
                models,
                origineleInfrastructuren,
                hasUnsavedChanges: hasUnsavedChanges,
                undoButtonDisabled: !hasUnsavedChanges,
                sportclubNaam: sportclubNaam,
                nieuweInfrastructuren,
                origineleNieuweInfrastructuren: nieuweInfrastructuren
            });
        }
        else {
            context.setState({
                sportclubId,
                models,
                hasUnsavedChanges: hasUnsavedChanges,
                undoButtonDisabled: !hasUnsavedChanges,
                sportclubNaam: sportclubNaam
            });
        }
        context.props.setHasUnsavedChanges(hasUnsavedChanges);
    }

    processAddInfrastructurenModel(model) {
        const context = this.context;
        let infrastructuren = [...model.data.items.map(x => mergeDeep({}, x))];

        context.setState({
            zoekModels: this.sortInfrastructuren(infrastructuren).map(x => mergeDeep({}, x)),
            totaalAantalZoekResultaten: model.data.totalItems
        });
    }

    change(event) {
        const value = event.target.checked;
        const property = event.target.name.split('_')[0];
        const id = event.target.name.split('_')[1];

        const context = this.context;
        const state = context.state;
        const models = [...state.models.map(x => mergeDeep({}, x))];
        let nieuweInfrastructuren = state.nieuweInfrastructuren;

        if (property === "domeinDeelVanSportclub") {
            models.filter(i => i.domeinId == id).map((infrastructuur) => {
                infrastructuur.deelVanSportclub = value;
                infrastructuur[property] = value;
            });
        }
        else if (property === "nieuweInfrastructuren") {
            nieuweInfrastructuren = event.target.value;
        }
        else {
            if (models[id]) {
                models[id][property] = value;
            }
            const infrastructurenInDomein = models.filter(i => i.domeinId == models[id].domeinId && (i.deelVanSportclub === true || i.deelVanSportclub == "true"));
            if (infrastructurenInDomein) {
                models.filter(i => i.domeinId == models[id].domeinId).map((i) => i.domeinDeelVanSportclub = (infrastructurenInDomein.length !== 0));
            }
        }

        context.setState({
            models,
            undoButtonDisabled: false,
            hasUnsavedChanges: true,
            nieuweInfrastructuren
        });
        this.context.state.hasUnsavedChanges === true || this.context.props.setHasUnsavedChanges(true);
    }

    undo() {
        const context = this.context;
        const state = this.context.state;
        const models = [...state.origineleInfrastructuren.map(x => mergeDeep({}, x))];

        context.setState({
            models,
            undoButtonDisabled: true,
            hasUnsavedChanges: false,
            nieuweInfrastructuren: state.origineleNieuweInfrastructuren
        });
        this.context.state.hasUnsavedChanges === false || this.context.props.setHasUnsavedChanges(false);
    }

    save() {
        const context = this.context;
        const props = context.props;
        const ajaxActions = context.props.ajaxActions;
        const state = context.state;
        const params = context.props.match.params;
        const transactieId = params.transactieId;

        ajaxActions.started();

        const modelToSave = {
            transactionId: transactieId,
            model: {
                id: state.sportclubId,
                infrastructuren: state.models,
                nieuweInfrastructuren: state.nieuweInfrastructuren
            }
        };

        infrastructuurApi.save(modelToSave)
            .then((response) => {
                ajaxActions.ended();
                this.processModel(response.data.item.model.infrastructuren, response.data.item.model.nieuweInfrastructuren, state.sportclubId, state.sportclubNaam, response.data.item.tabSettings, false, false, response.data.item.transactionId);
                showToastrSuccess(messages.MESSAGE_SAVED);
            })
            .catch((ex) => {
                ajaxActions.failed();
                if (ex.response.status === 404) {
                    showToastrError(messages.MESSAGE_NO_VALID_TRANSACTION_FOUND);
                    context.setState({ hasUnsavedChanges: false });
                    props.setHasUnsavedChanges(false);
                    this.redirector.goTo("/federatie/overzicht");
                }
                else {
                    props.throwException(ex, true);
                }
            });

        props.loadLayout(state.sportclubNaam);
    }

    add() {
        const context = this.context;

        context.props.loadAddInfrastructurenLayout(context.state.sportclubNaam);

        context.setState({
            showAddInfrastructurenForm: true,
            showNewInfrastructurenForm: false,
            hasUnsavedChanges: false,
            somethingChanged: false,
            nameFilterHasFocus: true
        });
        this.context.state.hasUnsavedChanges === false || context.props.setHasUnsavedChanges(false);
    }

    changeAddInfrastructuren(event) {
        const property = event.target.name;
        const value = event.target.value;
        const checked = event.target.checked;
        const context = this.context;
        const state = context.state;
        const zoekModels = [...state.zoekModels.map(x => mergeDeep({}, x))];

        if (property.toLowerCase().indexOf("deelVan".toLowerCase()) > -1) {
            const prop = event.target.name.split('_')[0];
            const id = parseInt(event.target.name.split('_')[1], 10);

            if (prop === "domeinDeelVanSportclub") {
                zoekModels.filter(i => i.domeinId == id).map((infrastructuur) => {
                    infrastructuur.deelVanSportclub = checked;
                    infrastructuur[prop] = checked;
                });
            }
            else {
                if (zoekModels[id]) {
                    zoekModels[id][prop] = checked;
                    const infrastructurenInDomein = zoekModels.filter(i => i.domeinId == zoekModels[id].domeinId && (i.deelVanSportclub === true || i.deelVanSportclub == "true"));
                    if (infrastructurenInDomein) {
                        zoekModels.filter(i => i.domeinId == zoekModels[id].domeinId).map((i) => i.domeinDeelVanSportclub = (infrastructurenInDomein.length !== 0));
                    }
                }
            }

            context.setState({
                zoekModels,
                somethingChanged: true,
                nameFilterHasFocus: false
            });
        }
        else {
            context.setState({
                [property]: value,
                nameFilterHasFocus: false
            });
        }
    }

    continue() {
        const context = this.context;
        const state = context.state;
        let models = [...state.models.map(x => mergeDeep({}, x))];
        const zoekModels = state.zoekModels;
        const toegevoegdeInfras = zoekModels.filter(i => i.deelVanSportclub);
        let nieuweDomeinen = [];

        if (toegevoegdeInfras.length > 0) {
            toegevoegdeInfras.forEach(t => {
                const domeinInModel = models.filter(m => m.domeinId === t.domeinId);

                if (domeinInModel.length === 0) {
                    nieuweDomeinen.push(t.domeinId);
                }
            }
            );

            if (nieuweDomeinen.length > 0) {
                this.getInfrasNieuweDomeinen(nieuweDomeinen);
            }
            else {
                this.processInfrasNieuweDomeinen([]);
            }
        }
        else {
            this.processInfrasNieuweDomeinen([]);
        }

        context.props.loadLayout(state.sportclubNaam);
    }

    processInfrasNieuweDomeinen(infrastructuren) {
        const context = this.context;
        const state = context.state;
        let models = [...state.models.map(x => mergeDeep({}, x))];
        const zoekModels = state.zoekModels;
        const toegevoegdeInfras = zoekModels.filter(i => i.deelVanSportclub);
        const undoButtonDisabled = state.undoButtonDisabled;

        if (toegevoegdeInfras.length > 0) {
            models = models.concat(zoekModels.filter(i => toegevoegdeInfras.map(x => x.domeinNaam).indexOf(i.domeinNaam) !== -1));
        }

        models = this.sortInfrastructuren(models.concat(infrastructuren.filter(i => models.map(m => m.id).indexOf(i.id) === -1 && i.domeinId !== 0).map(y => mergeDeep(y, { domeinDeelVanSportclub: true }))));

        context.setState({
            models,
            showAddInfrastructurenForm: false,
            showNewInfrastructurenForm: false,
            naamFilter: null,
            locatieFilter: null,
            sporttakFilter: null,
            aardFilter: null,
            zoekModels: [],
            hasUnsavedChanges: toegevoegdeInfras.length,
            undoButtonDisabled: !toegevoegdeInfras.length && undoButtonDisabled,
            somethingChanged: false
        });

        context.props.setHasUnsavedChanges(toegevoegdeInfras.length);
    }

    sortInfrastructuren(infrastructuren) {
        let infrasPerDomein = {};

        infrastructuren.forEach(element => {
			if (!Object.hasOwn(infrasPerDomein, element.domeinId)) {
                infrasPerDomein[element.domeinId] = [];
            }
            infrasPerDomein[element.domeinId].push(element);
        });
        let sortedDomeinen = {};
        Object.keys(infrasPerDomein).sort().forEach(key => {
            sortedDomeinen[key] = infrasPerDomein[key];
        });
        let sortedInfrastructuren = [];
        Object.keys(sortedDomeinen).forEach(key => {
            sortedDomeinen[key] = orderByPropertyName(sortedDomeinen[key], "infrastructuurNaam");
            sortedInfrastructuren = sortedInfrastructuren.concat(sortedDomeinen[key]);
        });

        return sortedInfrastructuren.sort((a, b) => (a.domeinNaam > b.domeinNaam) ? 1 : (a.domeinNaam < b.domeinNaam) ? -1 : 0);
    }

    cancel() {
        const context = this.context;
        const state = context.state;

        if (state.somethingChanged) {
            context.setState({
                hasUnsavedChanges: context.state.somethingChanged
            });
            this.context.state.hasUnsavedChanges === context.state.somethingChanged || context.props.setHasUnsavedChanges(context.state.somethingChanged);
        }
        else {
            context.setState({
                showAddInfrastructurenForm: false,
                showNewInfrastructurenForm: false,
                naamFilter: null,
                locatieFilter: null,
                sporttakFilter: null,
                aardFilter: null,
                somethingChanged: false,
                zoekModels: []
            });
        }

        context.props.loadLayout(state.sportclubNaam);
    }

    search() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const state = context.state;

        ajaxActions.started();
        infrastructuurApi.getInfrastructurenToAddByFilter({ naam: state.naamFilter, locatie: state.locatieFilter, sporttak: state.sporttakFilter, aard: state.aardFilter })
            .then((response) => {
                ajaxActions.ended();

                this.processAddInfrastructurenModel(response);
            })
            .catch((ex) => {
                context.props.throwException(ex);
            });
    }

    cancelUnsavedChanges() {
        const context = this.context;

        context.setState({
            hasUnsavedChanges: false
        });
        this.context.state.hasUnsavedChanges === false || context.props.setHasUnsavedChanges(false);
    }

    confirmUnsavedChanges() {
        const context = this.context;

        context.props.loadLayout(context.state.sportclubNaam);

        const showNewInfrastructurenForm = context.state.showNewInfrastructurenForm;

        context.setState({
            showAddInfrastructurenForm: showNewInfrastructurenForm,
            showNewInfrastructurenForm: false,
            naamFilter: showNewInfrastructurenForm ? context.state.naamFilter : null,
            locatieFilter: showNewInfrastructurenForm ? context.state.locatieFilter : null,
            sporttakFilter: showNewInfrastructurenForm ? context.state.sporttakFilter : null,
            aardFilter: showNewInfrastructurenForm ? context.state.aardFilter : null,
            somethingChanged: false,
            zoekModels: showNewInfrastructurenForm ? context.state.zoekModels : [],
            hasUnsavedChanges: false,
            nieuweInfrastructuren: ""
        });
    }

    getInfrasNieuweDomeinen(nieuweDomeinen) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        infrastructuurApi.listForAddedDomains(nieuweDomeinen)
            .then((response) => {
                ajaxActions.ended();
                this.processInfrasNieuweDomeinen(response.data);
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex, true);
            });
    }

    addNew() {
        const context = this.context;

        context.props.loadAddInfrastructurenLayout(context.state.sportclubNaam);

        context.setState({
            showAddInfrastructurenForm: false,
            showNewInfrastructurenForm: true,
            hasUnsavedChanges: false,
            somethingChanged: false
        });
        this.context.state.hasUnsavedChanges === false || context.props.setHasUnsavedChanges(false);
    }

    cancelNieuweInfrastructuren() {
        const context = this.context;
        const state = context.state;

        if (state.somethingChanged) {
            context.setState({
                hasUnsavedChanges: context.state.somethingChanged
            });
            this.context.state.hasUnsavedChanges === context.state.somethingChanged || context.props.setHasUnsavedChanges(context.state.somethingChanged);
        }
        else {
            context.setState({
                showAddInfrastructurenForm: true,
                showNewInfrastructurenForm: false,
                somethingChanged: false,
                nieuweInfrastructuren: ""
            });
        }

        context.props.loadLayout(state.sportclubNaam);
    }

    continueNieuweInfrastructuren() {
        const context = this.context;
        const state = context.state;
        const undoButtonDisabled = state.undoButtonDisabled;

        context.setState({
            showAddInfrastructurenForm: false,
            showNewInfrastructurenForm: false,
            hasUnsavedChanges: state.nieuweInfrastructuren,
            undoButtonDisabled: !state.nieuweInfrastructuren && undoButtonDisabled
        });

        context.props.setHasUnsavedChanges(state.nieuweInfrastructuren);
        context.props.loadLayout(state.sportclubNaam);
    }

    changeNieuweInfrastructuren(event) {
        const value = event.target.value;

        this.context.setState({
            nieuweInfrastructuren: value,
            somethingChanged: true,
            undoButtonDisabled: false,
            hasUnsavedChanges: !this.context.state.showNewInfrastructurenForm,
            nieuweInfraHasFocus: false
        });
    }
}
